module.exports = ".imgBoxItem { width: 100px; margin-right: 15px; float: left;  border: 1px solid #c5c5c5; background: #c5c5c5; margin-top: 10px; }"